import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";

import { Card, Icon, IconButton, Modal, Tab, Tabs } from "@mui/material";
import MDBox from "components/MDBox";
import { useState } from "react";
import parse from "html-react-parser";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "1000px",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
};

function MDModalAbas({
    show,
    close,
    header,
    dados,
    json }) {

    const [tabValue, setTabValue] = useState(1);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const containsHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

    const formatJSON = (json) => {
        try {
            return JSON.stringify(JSON.parse(json), null, 2) != 'null' ? JSON.stringify(JSON.parse(json), null, 2) : "Sem informações";
        } catch (error) {
            return json;
        }
    };

    return (
        <Modal
            open={show}
            onClose={close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Card sx={style}>
                <MDTypography id="modal-modal-title" variant="h6" component="h2" mb={3}>
                    {header}
                </MDTypography>
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    <MDTypography variant="body1" lineHeight={1}>
                        <Icon color="light">close</Icon>
                    </MDTypography>
                </IconButton>
                <MDBox sx={{ width: '100%', px: 2 }}>
                    <MDBox sx={{ borderBottom: 1, width: "100%", borderColor: 'divider' }}>
                        <Tabs value={tabValue} onChange={handleChange} aria-label="dados-json-tabs">
                            <Tab label="Dados" value={1} />
                            <Tab label="Json" value={2} />
                        </Tabs>
                    </MDBox>
                    <div
                        role="tabpanel"
                        hidden={tabValue !== 1}
                        id={`dados-${1}`}
                        aria-labelledby={`dados-${1}`}>
                        {tabValue === 1 &&
                            <MDBox
                                sx={{
                                    maxHeight: 400,
                                    overflowY: 'auto',
                                    padding: 2,
                                }}
                            >
                                <MDTypography variant="body1" component="div">
                                    {containsHTML(dados) ? (
                                        <span>{parse(dados)}</span>
                                    ) :
                                        <pre style={{
                                            whiteSpace: 'pre-wrap',
                                            wordWrap: 'break-word',
                                        }}>{formatJSON(dados)}</pre>
                                    }
                                </MDTypography>
                            </MDBox>
                        }
                    </div>
                    <div
                        role="tabpanel"
                        hidden={tabValue !== 2}
                        id={`json-${2}`}
                        aria-labelledby={`json-${2}`}>
                        {tabValue === 2 &&
                            <MDBox
                                sx={{
                                    maxHeight: 400,
                                    overflowY: 'auto',
                                    padding: 2,
                                }}
                            >
                                <MDTypography variant="body1" component="div">
                                    <pre>
                                        {formatJSON(json)}
                                    </pre>
                                </MDTypography>
                            </MDBox>}
                    </div>
                </MDBox>
            </Card>
        </Modal>
    );
}

// Typechecking props for the MDDatePicker
MDModalAbas.propTypes = {
    show: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
};

export default MDModalAbas;
